import { render, staticRenderFns } from "./TemplateInfo.vue?vue&type=template&id=23944bf8&scoped=true&"
import script from "./TemplateInfo.vue?vue&type=script&lang=js&"
export * from "./TemplateInfo.vue?vue&type=script&lang=js&"
import style0 from "./TemplateInfo.vue?vue&type=style&index=0&id=23944bf8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23944bf8",
  null
  
)

export default component.exports